export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40bcc90f3b4339be557697fb095e73eaf644fe02a8&name=addToFolderEventAction!'